"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var cov_2nkwt6s4xy = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/zip-core.js";
  var hash = "f9c033604c94f3faea4c063128e53b9590ccaffa";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/zip-core.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 17
        },
        end: {
          line: 10,
          column: 2
        }
      },
      "1": {
        start: {
          line: 13,
          column: 22
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 16,
          column: 17
        },
        end: {
          line: 16,
          column: 75
        }
      },
      "3": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 16
        }
      },
      "4": {
        start: {
          line: 20,
          column: 32
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "5": {
        start: {
          line: 24,
          column: 14
        },
        end: {
          line: 26,
          column: 4
        }
      },
      "6": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "7": {
        start: {
          line: 29,
          column: 16
        },
        end: {
          line: 29,
          column: 30
        }
      },
      "8": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "9": {
        start: {
          line: 32,
          column: 29
        },
        end: {
          line: 32,
          column: 52
        }
      },
      "10": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 50
        }
      },
      "11": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 22
        }
      },
      "12": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 21
        }
      },
      "13": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 18
        }
      },
      "14": {
        start: {
          line: 42,
          column: 29
        },
        end: {
          line: 57,
          column: 1
        }
      },
      "15": {
        start: {
          line: 46,
          column: 14
        },
        end: {
          line: 48,
          column: 4
        }
      },
      "16": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 55,
          column: 3
        }
      },
      "17": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 35
        }
      },
      "18": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 20
        }
      },
      "19": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 21
        }
      },
      "20": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 56,
          column: 18
        }
      },
      "21": {
        start: {
          line: 59,
          column: 22
        },
        end: {
          line: 74,
          column: 1
        }
      },
      "22": {
        start: {
          line: 63,
          column: 14
        },
        end: {
          line: 65,
          column: 4
        }
      },
      "23": {
        start: {
          line: 66,
          column: 18
        },
        end: {
          line: 66,
          column: 45
        }
      },
      "24": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 72,
          column: 3
        }
      },
      "25": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 41
        }
      },
      "26": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 49
        }
      },
      "27": {
        start: {
          line: 73,
          column: 2
        },
        end: {
          line: 73,
          column: 13
        }
      },
      "28": {
        start: {
          line: 76,
          column: 35
        },
        end: {
          line: 88,
          column: 1
        }
      },
      "29": {
        start: {
          line: 80,
          column: 14
        },
        end: {
          line: 82,
          column: 4
        }
      },
      "30": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 86,
          column: 3
        }
      },
      "31": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 22
        }
      },
      "32": {
        start: {
          line: 87,
          column: 2
        },
        end: {
          line: 87,
          column: 15
        }
      },
      "33": {
        start: {
          line: 90,
          column: 34
        },
        end: {
          line: 109,
          column: 1
        }
      },
      "34": {
        start: {
          line: 94,
          column: 14
        },
        end: {
          line: 96,
          column: 4
        }
      },
      "35": {
        start: {
          line: 98,
          column: 2
        },
        end: {
          line: 107,
          column: 3
        }
      },
      "36": {
        start: {
          line: 99,
          column: 20
        },
        end: {
          line: 99,
          column: 59
        }
      },
      "37": {
        start: {
          line: 100,
          column: 23
        },
        end: {
          line: 100,
          column: 41
        }
      },
      "38": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "39": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 46
        }
      },
      "40": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 99
        }
      },
      "41": {
        start: {
          line: 108,
          column: 2
        },
        end: {
          line: 108,
          column: 14
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 22
          },
          end: {
            line: 13,
            column: 23
          }
        },
        loc: {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 32
          },
          end: {
            line: 20,
            column: 33
          }
        },
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 22
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 42,
            column: 29
          },
          end: {
            line: 42,
            column: 30
          }
        },
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 57,
            column: 1
          }
        },
        line: 44
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 59,
            column: 22
          },
          end: {
            line: 59,
            column: 23
          }
        },
        loc: {
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 74,
            column: 1
          }
        },
        line: 61
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 76,
            column: 35
          },
          end: {
            line: 76,
            column: 36
          }
        },
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 88,
            column: 1
          }
        },
        line: 78
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 90,
            column: 34
          },
          end: {
            line: 90,
            column: 35
          }
        },
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 109,
            column: 1
          }
        },
        line: 92
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 15
          },
          end: {
            line: 14,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 22
          },
          end: {
            line: 14,
            column: 30
          }
        }],
        line: 14
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }],
        line: 31
      },
      "2": {
        loc: {
          start: {
            line: 31,
            column: 8
          },
          end: {
            line: 31,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 8
          },
          end: {
            line: 31,
            column: 26
          }
        }, {
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 31,
            column: 46
          }
        }],
        line: 31
      },
      "3": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        }, {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        }],
        line: 68
      },
      "4": {
        loc: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        }, {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        }],
        line: 84
      },
      "5": {
        loc: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 107,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 107,
            column: 3
          }
        }, {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 107,
            column: 3
          }
        }],
        line: 98
      },
      "6": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }],
        line: 102
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "f9c033604c94f3faea4c063128e53b9590ccaffa"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileFromRepoZip = exports.getFilesFromRepoZip = exports.getZip = exports.removeRepoZip = exports.storeZipFromRepo = exports.zipUri = void 0;

var _path = _interopRequireDefault(require("path"));

var _jszip = _interopRequireDefault(require("jszip"));

var _localforage = _interopRequireDefault(require("localforage"));

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var zipStore = (cov_2nkwt6s4xy.s[0]++, _localforage.default.createInstance({
  driver: [_localforage.default.INDEXEDDB],
  name: 'zip-store'
})); // https://git.door43.org/unfoldingWord/en_ult/archive/master.zip

cov_2nkwt6s4xy.s[1]++;

var zipUri = function zipUri(_ref) {
  var owner = _ref.owner,
      repo = _ref.repo,
      _ref$branch = _ref.branch,
      branch = _ref$branch === void 0 ? (cov_2nkwt6s4xy.b[0][0]++, 'master') : _ref$branch,
      server = _ref.server;
  cov_2nkwt6s4xy.f[0]++;
  var zipUri = (cov_2nkwt6s4xy.s[2]++, _path.default.join(server, owner, repo, 'archive', "".concat(branch, ".zip")));
  cov_2nkwt6s4xy.s[3]++;
  return zipUri;
};

exports.zipUri = zipUri;
cov_2nkwt6s4xy.s[4]++;

var storeZipFromRepo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var owner, repo, branch, server, response, uri, zip, zipArrayBuffer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            owner = _ref2.owner, repo = _ref2.repo, branch = _ref2.branch, server = _ref2.server;
            cov_2nkwt6s4xy.f[1]++;
            uri = (cov_2nkwt6s4xy.s[5]++, zipUri({
              owner: owner,
              repo: repo,
              branch: branch,
              server: server
            }));
            cov_2nkwt6s4xy.s[6]++;
            _context.prev = 4;
            cov_2nkwt6s4xy.s[7]++;
            _context.next = 8;
            return (0, _.get)(uri);

          case 8:
            zip = _context.sent;
            cov_2nkwt6s4xy.s[8]++;

            if (!((cov_2nkwt6s4xy.b[2][0]++, zip.status === 200) || (cov_2nkwt6s4xy.b[2][1]++, zip.status === 0))) {
              _context.next = 23;
              break;
            }

            cov_2nkwt6s4xy.b[1][0]++;
            cov_2nkwt6s4xy.s[9]++;
            _context.next = 15;
            return zip.arrayBuffer();

          case 15:
            zipArrayBuffer = _context.sent;
            // blob storage not supported on mobile
            cov_2nkwt6s4xy.s[10]++;
            _context.next = 19;
            return zipStore.setItem(uri, zipArrayBuffer);

          case 19:
            cov_2nkwt6s4xy.s[11]++;
            response = true;
            _context.next = 24;
            break;

          case 23:
            cov_2nkwt6s4xy.b[1][1]++;

          case 24:
            _context.next = 30;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](4);
            cov_2nkwt6s4xy.s[12]++;
            response = false;

          case 30:
            ;
            cov_2nkwt6s4xy.s[13]++;
            return _context.abrupt("return", response);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 26]]);
  }));

  return function storeZipFromRepo(_x) {
    return _ref3.apply(this, arguments);
  };
}();

exports.storeZipFromRepo = storeZipFromRepo;
cov_2nkwt6s4xy.s[14]++;

var removeRepoZip = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
    var owner, repo, branch, server, response, uri;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            owner = _ref4.owner, repo = _ref4.repo, branch = _ref4.branch, server = _ref4.server;
            cov_2nkwt6s4xy.f[2]++;
            uri = (cov_2nkwt6s4xy.s[15]++, zipUri({
              owner: owner,
              repo: repo,
              branch: branch,
              server: server
            }));
            cov_2nkwt6s4xy.s[16]++;
            _context2.prev = 4;
            cov_2nkwt6s4xy.s[17]++;
            _context2.next = 8;
            return zipStore.removeItem(uri);

          case 8:
            cov_2nkwt6s4xy.s[18]++;
            response = true;
            _context2.next = 16;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](4);
            cov_2nkwt6s4xy.s[19]++;
            response = false;

          case 16:
            ;
            cov_2nkwt6s4xy.s[20]++;
            return _context2.abrupt("return", response);

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 12]]);
  }));

  return function removeRepoZip(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

exports.removeRepoZip = removeRepoZip;
cov_2nkwt6s4xy.s[21]++;

var getZip = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
    var owner, repo, branch, config, zip, uri, zipBlob;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            owner = _ref6.owner, repo = _ref6.repo, branch = _ref6.branch, config = _ref6.config;
            cov_2nkwt6s4xy.f[3]++;
            uri = (cov_2nkwt6s4xy.s[22]++, zipUri({
              owner: owner,
              repo: repo,
              branch: branch,
              config: config
            }));
            cov_2nkwt6s4xy.s[23]++;
            _context3.next = 6;
            return zipStore.getItem(uri);

          case 6:
            zipBlob = _context3.sent;
            cov_2nkwt6s4xy.s[24]++;

            if (!zipBlob) {
              _context3.next = 16;
              break;
            }

            cov_2nkwt6s4xy.b[3][0]++;
            cov_2nkwt6s4xy.s[25]++;
            _context3.next = 13;
            return _jszip.default.loadAsync(zipBlob);

          case 13:
            zip = _context3.sent;
            _context3.next = 19;
            break;

          case 16:
            cov_2nkwt6s4xy.b[3][1]++;
            cov_2nkwt6s4xy.s[26]++;
            console.log("No zip file found for ".concat(uri, "."));

          case 19:
            ;
            cov_2nkwt6s4xy.s[27]++;
            return _context3.abrupt("return", zip);

          case 22:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getZip(_x3) {
    return _ref7.apply(this, arguments);
  };
}();

exports.getZip = getZip;
cov_2nkwt6s4xy.s[28]++;

var getFilesFromRepoZip = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
    var owner, repo, branch, config, files, zip;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            owner = _ref8.owner, repo = _ref8.repo, branch = _ref8.branch, config = _ref8.config;
            cov_2nkwt6s4xy.f[4]++;
            cov_2nkwt6s4xy.s[29]++;
            _context4.next = 5;
            return getZip({
              owner: owner,
              repo: repo,
              branch: branch,
              config: config
            });

          case 5:
            zip = _context4.sent;
            cov_2nkwt6s4xy.s[30]++;

            if (zip) {
              cov_2nkwt6s4xy.b[4][0]++;
              cov_2nkwt6s4xy.s[31]++;
              files = zip.files;
            } else {
              cov_2nkwt6s4xy.b[4][1]++;
            }

            ;
            cov_2nkwt6s4xy.s[32]++;
            return _context4.abrupt("return", files);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getFilesFromRepoZip(_x4) {
    return _ref9.apply(this, arguments);
  };
}();

exports.getFilesFromRepoZip = getFilesFromRepoZip;
cov_2nkwt6s4xy.s[33]++;

var getFileFromRepoZip = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref10) {
    var owner, repo, branch, filepath, config, file, zip, zipPath, fileObject;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            owner = _ref10.owner, repo = _ref10.repo, branch = _ref10.branch, filepath = _ref10.filepath, config = _ref10.config;
            cov_2nkwt6s4xy.f[5]++;
            zip = (cov_2nkwt6s4xy.s[34]++, getZip({
              owner: owner,
              repo: repo,
              branch: branch,
              config: config
            }));
            cov_2nkwt6s4xy.s[35]++;

            if (!zip) {
              _context5.next = 23;
              break;
            }

            cov_2nkwt6s4xy.b[5][0]++;
            zipPath = (cov_2nkwt6s4xy.s[36]++, _path.default.join(repo.toLowerCase(), filepath));
            fileObject = (cov_2nkwt6s4xy.s[37]++, zip.files[zipPath]);
            cov_2nkwt6s4xy.s[38]++;

            if (!fileObject) {
              _context5.next = 17;
              break;
            }

            cov_2nkwt6s4xy.b[6][0]++;
            cov_2nkwt6s4xy.s[39]++;
            _context5.next = 14;
            return fileObject.async('string');

          case 14:
            file = _context5.sent;
            _context5.next = 20;
            break;

          case 17:
            cov_2nkwt6s4xy.b[6][1]++;
            cov_2nkwt6s4xy.s[40]++;
            console.log("Filepath ".concat(filepath, " not found in ").concat(config.server, "/").concat(owner, "/").concat(repo, "/").concat(branch));

          case 20:
            ;
            _context5.next = 24;
            break;

          case 23:
            cov_2nkwt6s4xy.b[5][1]++;

          case 24:
            ;
            cov_2nkwt6s4xy.s[41]++;
            return _context5.abrupt("return", file);

          case 27:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getFileFromRepoZip(_x5) {
    return _ref11.apply(this, arguments);
  };
}();

exports.getFileFromRepoZip = getFileFromRepoZip;